import { render, staticRenderFns } from "./scrollTable.vue?vue&type=template&id=0c966685&scoped=true"
import script from "./scrollTable.vue?vue&type=script&lang=js"
export * from "./scrollTable.vue?vue&type=script&lang=js"
import style0 from "./scrollTable.vue?vue&type=style&index=0&id=0c966685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c966685",
  null
  
)

export default component.exports